import { IoIosArrowDown } from 'react-icons/io';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Card = styled.div`
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 48px;
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.flightDetails.card.boxShadow};
`;

export const AlwaysVisible: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
`;

AlwaysVisible.Title = styled.span`
  font-size: 14px;
  font-weight: 600;
  padding-right: 10px;
  color: ${({ theme }) => theme.flightDetails.card.title};
`;

AlwaysVisible.Arrow = styled(IoIosArrowDown)`
  font-size: 20px;
  padding: 0 2px;
  box-sizing: content-box;
  color: ${({ theme }) => theme.flightDetails.card.arrowDown} !important;

  &.active {
    transform: rotate(-180deg);
  }
`;

export const Row = styled.div`
  padding: 12px 0;

  &:first-child {
    padding-top: 24px;
  }
`;

export const Label = styled.span`
  color: ${ColorPalette.HEX.Manatee};
`;

export const Value = styled.span`
  color: ${ColorPalette.HEX.OuterSpace};
`;
